var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.active)?_c('DateOfBirth',{attrs:{"value":_vm.profile}}):_vm._e(),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.profile.bornAt,"block":""},on:{"click":function($event){return _vm.$emit('input')}}},[_vm._v("\n    Save\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }